// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
._19itglyw{border:none}._154ipxbi{top:var(--ds-space-200,1pc)}
._1ltvpxbi{left:var(--ds-space-200,1pc)}
._kqswstnw{position:absolute}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/give-kudos/dist/esm/ui/GiveKudosLauncher/main.compiled.css"],"names":[],"mappings":";AACA,WAAW,WAAW,CAAC,WAAW,2BAA2B;AAC7D,WAAW,4BAA4B;AACvC,WAAW,iBAAiB","sourcesContent":["\n._19itglyw{border:none}._154ipxbi{top:var(--ds-space-200,1pc)}\n._1ltvpxbi{left:var(--ds-space-200,1pc)}\n._kqswstnw{position:absolute}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
